import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import { Flex, FieldSet, Legend, IconCircle } from "@zillow/constellation";
import { FieldConfig } from "./MortgageRateTrends.utils.esm.js";
import CheckboxField from "../Fields/CheckboxField.esm.js";
import SelectField from "../Fields/SelectField.esm.js";
import { PROGRAM_COLOR_CODE, LOAN_PROGRAMS } from "./constants.esm.js";
const LoanProgramLabel = ({
  program,
  color
}) => /* @__PURE__ */ jsxs(Flex, { style: {
  display: "flex",
  alignItems: "center"
}, children: [
  /* @__PURE__ */ jsx(IconCircle, { style: {
    "margin-right": "6px"
  }, size: "xs", color, display: "inline-block" }),
  LOAN_PROGRAMS[program]
] });
const MortgageRateTrendsFields = () => {
  return /* @__PURE__ */ jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxs(Flex, { display: "flex", flexDirection: {
    default: "column",
    md: "row"
  }, children: [
    /* @__PURE__ */ jsx(Flex, { flex: "1 1 auto", marginRight: {
      lg: "md"
    }, children: /* @__PURE__ */ jsxs(FieldSet, { legend: /* @__PURE__ */ jsx(Legend, { children: "LOAN PROGRAMS" }), children: [
      /* @__PURE__ */ jsx(CheckboxField, { label: /* @__PURE__ */ jsx(LoanProgramLabel, { program: FieldConfig.Fixed30Year.name, color: PROGRAM_COLOR_CODE[FieldConfig.Fixed30Year.name] }), name: FieldConfig.Fixed30Year.name }),
      /* @__PURE__ */ jsx(CheckboxField, { label: /* @__PURE__ */ jsx(LoanProgramLabel, { program: FieldConfig.Fixed20Year.name, color: PROGRAM_COLOR_CODE[FieldConfig.Fixed20Year.name] }), name: FieldConfig.Fixed20Year.name }),
      /* @__PURE__ */ jsx(CheckboxField, { label: /* @__PURE__ */ jsx(LoanProgramLabel, { program: FieldConfig.Fixed15Year.name, color: PROGRAM_COLOR_CODE[FieldConfig.Fixed15Year.name] }), name: FieldConfig.Fixed15Year.name }),
      /* @__PURE__ */ jsx(CheckboxField, { label: /* @__PURE__ */ jsx(LoanProgramLabel, { program: FieldConfig.Fixed10Year.name, color: PROGRAM_COLOR_CODE[FieldConfig.Fixed10Year.name] }), name: FieldConfig.Fixed10Year.name }),
      /* @__PURE__ */ jsx(CheckboxField, { label: /* @__PURE__ */ jsx(LoanProgramLabel, { program: FieldConfig.ARM7.name, color: PROGRAM_COLOR_CODE[FieldConfig.ARM7.name] }), name: FieldConfig.ARM7.name }),
      /* @__PURE__ */ jsx(CheckboxField, { label: /* @__PURE__ */ jsx(LoanProgramLabel, { program: FieldConfig.ARM5.name, color: PROGRAM_COLOR_CODE[FieldConfig.ARM5.name] }), name: FieldConfig.ARM5.name }),
      /* @__PURE__ */ jsx(CheckboxField, { label: /* @__PURE__ */ jsx(LoanProgramLabel, { program: FieldConfig.ARM3.name, color: PROGRAM_COLOR_CODE[FieldConfig.ARM5.name] }), name: FieldConfig.ARM3.name })
    ] }) }),
    /* @__PURE__ */ jsxs(Flex, { flex: "1 1 auto", marginRight: {
      lg: "md"
    }, children: [
      /* @__PURE__ */ jsx(SelectField, { options: FieldConfig.loanPurpose.options, label: "Loan purpose", name: FieldConfig.loanPurpose.name, config: FieldConfig.loanPurpose.config }),
      /* @__PURE__ */ jsx(SelectField, { options: FieldConfig.creditRating.options, label: "Credit rating", name: FieldConfig.creditRating.name, config: FieldConfig.creditRating.config }),
      /* @__PURE__ */ jsx(SelectField, { options: FieldConfig.percentDown.options, label: "Percent down", name: FieldConfig.percentDown.name, config: FieldConfig.percentDown.config }),
      /* @__PURE__ */ jsx(SelectField, { options: FieldConfig.location.options, label: "Location", name: FieldConfig.location.name, config: FieldConfig.location.config }),
      /* @__PURE__ */ jsx(SelectField, { options: FieldConfig.timeSpan.options, label: "Timespan", name: FieldConfig.timeSpan.name, config: FieldConfig.timeSpan.config })
    ] })
  ] }) });
};
export {
  MortgageRateTrendsFields as default
};
